/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SchedulingStrategyConfig } from './SchedulingStrategyConfig';
import {
    SchedulingStrategyConfigFromJSON,
    SchedulingStrategyConfigFromJSONTyped,
    SchedulingStrategyConfigToJSON,
    SchedulingStrategyConfigToJSONTyped,
} from './SchedulingStrategyConfig';
import type { AvailabilityWindow } from './AvailabilityWindow';
import {
    AvailabilityWindowFromJSON,
    AvailabilityWindowFromJSONTyped,
    AvailabilityWindowToJSON,
    AvailabilityWindowToJSONTyped,
} from './AvailabilityWindow';

/**
 * 
 * @export
 * @interface ConfigurationBasedStrategyConfig
 */
export interface ConfigurationBasedStrategyConfig extends SchedulingStrategyConfig {
    /**
     * 
     * @type {number}
     * @memberof ConfigurationBasedStrategyConfig
     */
    slotDuration: number;
    /**
     * 
     * @type {Array<AvailabilityWindow>}
     * @memberof ConfigurationBasedStrategyConfig
     */
    availabilityWindows: Array<AvailabilityWindow>;
    /**
     * 
     * @type {number}
     * @memberof ConfigurationBasedStrategyConfig
     */
    bufferBetweenSlots: number;
    /**
     * How many days in advance to generate slots.
     * @type {number}
     * @memberof ConfigurationBasedStrategyConfig
     */
    advanceBookingDays: number;
    /**
     * The last possible bookable Instant, after this the Meeting is considered expired.
     * @type {Date}
     * @memberof ConfigurationBasedStrategyConfig
     */
    lastBookableDate?: Date;
}

/**
 * Check if a given object implements the ConfigurationBasedStrategyConfig interface.
 */
export function instanceOfConfigurationBasedStrategyConfig(value: object): value is ConfigurationBasedStrategyConfig {
    if (!('slotDuration' in value) || value['slotDuration'] === undefined) return false;
    if (!('availabilityWindows' in value) || value['availabilityWindows'] === undefined) return false;
    if (!('bufferBetweenSlots' in value) || value['bufferBetweenSlots'] === undefined) return false;
    if (!('advanceBookingDays' in value) || value['advanceBookingDays'] === undefined) return false;
    return true;
}

export function ConfigurationBasedStrategyConfigFromJSON(json: any): ConfigurationBasedStrategyConfig {
    return ConfigurationBasedStrategyConfigFromJSONTyped(json, false);
}

export function ConfigurationBasedStrategyConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigurationBasedStrategyConfig {
    if (json == null) {
        return json;
    }
    return {
        ...SchedulingStrategyConfigFromJSONTyped(json, true),
        'slotDuration': json['slotDuration'],
        'availabilityWindows': ((json['availabilityWindows'] as Array<any>).map(AvailabilityWindowFromJSON)),
        'bufferBetweenSlots': json['bufferBetweenSlots'],
        'advanceBookingDays': json['advanceBookingDays'],
        'lastBookableDate': json['lastBookableDate'] == null ? undefined : (new Date(json['lastBookableDate'])),
    };
}

export function ConfigurationBasedStrategyConfigToJSON(json: any): ConfigurationBasedStrategyConfig {
    return ConfigurationBasedStrategyConfigToJSONTyped(json, false);
}

export function ConfigurationBasedStrategyConfigToJSONTyped(value?: ConfigurationBasedStrategyConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        ...SchedulingStrategyConfigToJSONTyped(value, true),
        'slotDuration': value['slotDuration'],
        'availabilityWindows': ((value['availabilityWindows'] as Array<any>).map(AvailabilityWindowToJSON)),
        'bufferBetweenSlots': value['bufferBetweenSlots'],
        'advanceBookingDays': value['advanceBookingDays'],
        'lastBookableDate': value['lastBookableDate'] == null ? value['lastBookableDate'] : value['lastBookableDate'].toISOString(),
    };
}

